const convertToYesOrNo = (data) => {
  if (!data) return false;
  return data === "1" ? "Yes" : "No";
}


export const ClientCounterpartyFactory = (entityId, details = {}) => {
    return {
        entityId: details.entityId || entityId || "",
        clientType: details.vendor_type || details.clientType || "",
        transactionType: details.entity_type || details.transactionType || "",
        transactionReference: details.RegulatoryReferenceNumber || details.transactionReference || "",
        description: details.description || "",
        sourceOfFunds: details.sourceOfFunds || "",
        headsOfTermDate: details.headsOfTermDate || "",
        anticipatedCompletionDate: details.anticipatedCompletionDate || "",
        entityName: details.ThirdPartyRelianceName || details.entityName || "",
        companyName: details.Company_name || details.entityName ||  "",
        countryOfIncorporation: details.Country_incorporation || details.countryOfIncorporation || "",
        companyType: details.Company_type || details.companyType || "",
        registrationNumber: details.RegistrationNumber || details.registrationNumber || "",
        addressLine1: details.EntityAddressLin1 || details.addressLine1 || "",
        regulatoryBody: details.RegulatoryBodyName || details.regulatoryBody || "",
        isRegulatoryListed: details.IsRecognisedRegulatoryBody ? convertToYesOrNo(details.IsRecognisedRegulatoryBody) : details.isRegulatoryListed || "", 
        regulatoryReferenceNumber: details.RegulatoryReferenceNumber || details.regulatoryReferenceNumber || "",
        overseasEntitiesNumber: details.RegisteredOverseasEntitiesNumber  || details.overseasEntitiesNumber || "",
        overseasEntities:  details.IsRegisteredOverseas ? convertToYesOrNo(details.IsRegisteredOverseas) : details.overseasEntities || "",
        isBillingRecognized: details.IsListedOnRecognisedExchange ? convertToYesOrNo(details.IsListedOnRecognisedExchange) : details.isBillingRecognized || "",
        isBillingEntityListed: details.IsListedOnRecognisedExchange ? convertToYesOrNo(details.IsListedOnRecognisedExchange) : details.isBillingEntityListed || "",
        addressLine2: details.EntityAddressLin2 || details.addressLine2 || "",
        addressLine3: details.EntityAddressLin3 || details.addressLine3 || "",
        state: details.Entitystate || details.state || "",
        city: details.EntityCity || details.city || "",
        recognisedExchange: details.RecognisedExchangeName || details.recognisedExchange || "",
        postCode: details.EntityPostcode || details.postCode || "",
        existingProperty: details.ExistingProperty || details.existingProperty || "",
        landRegisterCopy: details.IsLandRegistryCopyAvailable ? convertToYesOrNo(details.IsLandRegistryCopyAvailable) : details.landRegisterCopy || "",
        relianceFromThirdParty: details.IsThirdPartyRelianceEnabled ? convertToYesOrNo(details.IsThirdPartyRelianceEnabled) : details.relianceFromThirdParty || "",
        compliantLetter: details.IsThirdPartyCompliantLetterAvailable ? convertToYesOrNo(details.IsThirdPartyCompliantLetterAvailable) : details.compliantLetter || "",
        complyWithRegulations: details.IsThirdPartySection39Complaint ? convertToYesOrNo(details.IsThirdPartySection39Complaint) : details.complyWithRegulations || "",
        regulatoryBodyAutorizedBy: details.ThirdPartyRegulatoryBodyAuthorisedBy || details.regulatoryBody || "",
        entityType: details.entity_type || details.entityType || "",
        ThirdPartyRelianceType: details.ThirdPartyRelianceType || "",
        status: details.entity_Status || details.status || "Not Validated",
        entityStatus: details.entity_Status || details.status || "Not Validated",
        diligenceStatus: details.diligenceStatus ? details.diligenceStatus.toLowerCase() : "standard",
        otherRegulatoryBody: details.otherRegulatoryBody || "",
        otherRegulatedEntity: details.otherRegulatedEntity || "",
        clientReferenceNumber: details.Client_reference_number || details.clientReferenceNumber || "",

      }
}